
<template>
  <span>

    <b-container fluid>
      <b-row class="table-header">
        <b-col cols="12" sm="6" lg="3">
          <b-form-group>
            <b-form-input
              ref="search"
              v-model="meta.search"
              :disabled="fetching"
              placeholder="Search by title"
              @keyup.native="search"
              @input="searchChanged"/>
          </b-form-group>
        </b-col>
      </b-row>

      <no-data v-if="noData" :message="noDocumentsFoundMessage"/>

      <b-table
        v-if="tableData.length"
        :hover="rowClickEnabled && !fetching"
        :responsive="true"
        :busy="fetching"
        :items="tableData"
        :fields="formFields"
        :per-page="Number(meta.per_page)"
        :sort-by="meta.order"
        :sort-desc="meta.desc"
        :no-local-sorting="true"
        @sort-changed="sortChanged"
        @row-clicked="rowClicked">

        <template slot="title" slot-scope="data">
          <div class="name-wrapper">
            {{ data.value }}
          </div>
        </template>
        
        <template slot="status" slot-scope="data">
          <span v-if="data.value === 'match'" class="bioreq-match">{{ data.value }}</span>
          <span v-else-if="data.value === 'nomatch'" class="bioreq-nomatch">no match</span>
        </template>

        <template slot="submitter" slot-scope="data">
          {{ data.value }}
        </template>

        <template slot="created" slot-scope="data">
          {{ readableDate(data.value) }}
        </template>

        <template slot="actions" slot-scope="data">
          <div class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="download">
              <b-button
                :disabled="fetching"
                class="table-button"
                title="download"
                variant="outline-secondary"
                @click.stop="download(data.item)">
                <i class="fas fa-download"></i>
              </b-button>
            </span>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col cols="12">
          <b-pagination
            v-if="data.length"
            :disabled="fetching"
            :value="Number(meta.current_page)"
            :total-rows="Number(meta.total)"
            :per-page="Number(meta.per_page)"
            @change="pageChanged"/>
        </b-col>
      </b-row>
      
    </b-container>

    <b-modal id="bioreqModal"
             v-model="showBioreqModal"
             :title="bioreqTitle"
             centered 
             hide-footer
             size="md">
      <b-form>
        <b-form-group label="Description:">
          {{ bioreqDescription }}
        </b-form-group>
        <b-form-group label="File type:">
          {{ bioreqFileType }}
        </b-form-group>
        <b-button class="btn btn-primary pull-right" @click="closeBioreqModal">Close</b-button>
      </b-form>
    </b-modal>
  </span>
</template>

<script>
import tableMixin from '../../mixins/admin-table'
import downloader from 'downloadjs'

export default {
  mixins: [tableMixin],
  props: {
    tableType: {
      type: String,
      required: false,
      default: ''
    },
    idsToHighlight: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      formFields: [
        { key: 'title', label: 'Title', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'submitter', label: 'Uploaded By', sortable: true },
        { key: 'created', label: 'Uploaded', sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      editRoute: 'admin-edit-bioreq',
      namespace: 'bioreq',
      routeParamName: 'bioreq',
      showBioreqModal: false,
      bioreqTitle: '',
      bioreqDescription: '',
      bioreqFileType: ''
    }
  },
  computed: {
    tableData () {
      return this.data.map((bioreq) => {
        let _rowVariant = null
        if (this.idsToHighlight.indexOf(bioreq.id) !== -1) {
          _rowVariant = 'success'
        }
        return { ...bioreq, _rowVariant }
      })
    },
    noDocumentsFoundMessage () {
      return `No ${this.tableType} bioreq documents found`
    }
  },
  methods: {
    rowClicked (item, index, e) {
      if (this.rowClickEnabled) {
        this.bioreqTitle = item.title
        this.bioreqDescription = item.description
        this.bioreqFileType = item.mime_type
        this.showBioreqModal = true
      }
    },
    closeBioreqModal () {
      this.showBioreqModal = false
    },
    match (bioreqId) {
      this.$store.dispatch('bioreq/match', bioreqId)
    },
    noMatch (bioreqId) {
      this.$store.dispatch('bioreq/noMatch', bioreqId)
    },
    download (bioreq) {
      this.$store.dispatch('bioreq/download', bioreq.id)

      const xhr = new XMLHttpRequest()
      xhr.open('GET', bioreq.url, bioreq.id, true)
      xhr.responseType = 'blob'
      xhr.onload = (e) => {
        downloader(e.target.response, bioreq.title)
      }
      xhr.send()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

  .bioreq-match {
    color: $success-secondary;
    font-weight: 600;
  }
  .bioreq-nomatch {
    color: $error-secondary;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/bioreq/processedTable.vue